import { render } from "./OcrReportDocument.vue?vue&type=template&id=f13fa042"
import script from "./OcrReportDocument.vue?vue&type=script&lang=js"
export * from "./OcrReportDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__